export const className = 'wp-block-webdevia-rental-dates'
export let selectedAddons = []
export let selectedFees = []

export const getSelectedAddons = () => selectedAddons
export const getSelectedFees = () => selectedFees

export const addAddon = (addon) => {
  if (!selectedAddons.some(item => item.id === addon.id)) {
    selectedAddons.push(addon)
  }
}

export const addFee = (fee) => {
  if (!selectedFees.some(item => item === fee)) {
    selectedFees.push(fee)
  }
}

export const removeAddon = (addonId) => {
  selectedAddons = selectedAddons.filter(item => item.id !== addonId)
}

export const removeFee = (feeId) => {
  selectedFees = selectedFees.filter(item => item !== feeId)
}

export const formattedDate = ( date, time) => {
  let month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1,
      day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate(),
      hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours(),
      minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes(),
      seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds(),
      dateString
  dateString = `${date.getFullYear()}-${month}-${day}`
  dateString += time ? ` ${hours}:${minutes}:${seconds}` : ``
  return dateString
}

export const createCookie = (name, date) => {
  document.cookie = name + '=' + date + "; path=/";
}

// get cookie
export const getCookie = (c_name) => {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      var c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) {
        c_end = document.cookie.length;
      }
      
      return document.cookie.substring(c_start, c_end);
    }
  }
  return "";
}

// delete cookie
export const deleteCookie = (name) => {
  createCookie(name, '');
}

export const preparePriceRequest = (options, quantity) => {
  let d = []
  const dateTimeListItem = document.querySelectorAll(`.${className}__list__input`)
  dateTimeListItem.forEach(dateTime => {
    if(dateTime.dataset.item_dates) {
      const itemDates = JSON.parse(dateTime.dataset.item_dates),
            startTimePicker = dateTime.querySelector('#startTimePicker'),
            startHours = !!startTimePicker ? startTimePicker.value.split( '.' ) : undefined,
            startDate = new Date(itemDates.startDateTime),
            endTimePicker = dateTime.querySelector('#endTimePicker'),
            endHours = !!endTimePicker ? endTimePicker.value.split( '.' ) : undefined,
            endDate = new Date(itemDates.endDateTime)
            
      if ( !!startTimePicker ) startDate.setHours( parseFloat( startHours[0] ) , parseFloat( startHours[1] ), 0 )
      if ( !!endTimePicker ) endDate.setHours(parseFloat(endHours[0]), parseFloat(endHours[1]), 0)
      d.push({
        startDateTime: formattedDate( startDate, true ),
        endDateTime: formattedDate( endDate, true ),
        quantity
      })
    }
  })
  priceAndDuration( options, d, quantity )
  if( getCookie('rental_dates_cookie') ) {
    deleteCookie('rental_dates_cookie')
  }
  createCookie('rental_dates_cookie', JSON.stringify(d))
}

export const  extractTotalHours = (timeString) => {
  // Regular expressions to capture days and hours
  const dayMatch = timeString.match(/(\d+)\s*day/);
  const hourMatch = timeString.match(/(\d+)\s*hour/);
  
  // Extract days and hours
  const days = dayMatch ? parseInt(dayMatch[1], 10) : 0;
  const hours = hourMatch ? parseInt(hourMatch[1], 10) : 0;
  
  // Calculate total hours
  return days * 24 + hours;
}

export const priceAndDuration = ( options, selectedDates, quantity ) => {
  const DONE = 4, OK = 200
  let messageBox = document.querySelector(`.wp-block-webdevia-rental-dates__message-box`)
  const responseContainer = document.querySelector( '.wp-block-webdevia-rental-add-to-card #durationAndPrice' )
  responseContainer.style.display = 'block'
  responseContainer.innerHTML = '<div class="spiner-container"><span class="spin"></span>...loading</div>'
  
  let formData = new FormData()
  formData.append( 'action', 'backhoe_booking_check_availability' )
  formData.append( 'product_id', options.product_id )
  formData.append( 'variation_id', options.variation_id )
  formData.append( 'dates', JSON.stringify( selectedDates ) )
  formData.append( 'quantity', quantity ? quantity : 1 )
  formData.append( 'price', options.price )
  formData.append( 'addons', getSelectedAddons().length ? JSON.stringify( getSelectedAddons() ) : null )
  formData.append( 'fees', selectedFees.length == 0 ? null : selectedFees )
  // console.log( devia.ajax_url, [ ...formData.entries() ] )

  let xhttp = new XMLHttpRequest()
  xhttp.onreadystatechange = () => {
    if( xhttp.readyState == DONE && xhttp.status == OK ) {
      const response = JSON.parse( xhttp.responseText )
      if ( !!responseContainer ) {
        if( response.success ) {
          responseContainer.innerHTML = response.results.content
          // @if type = 'pro'
          if( parseInt( extractTotalHours(response.results.hours) ) < parseInt ( options.min_hour ) && options.hourly_pricing ) {
            messageBox.innerHTML = `Please select more than ${options.min_hour} hours!`
            messageBox.style.display = 'block'
            responseContainer.style.display = 'none'
          } else {
            messageBox.innerHTML = ``
            messageBox.style.display = 'none'
          }
        } else {
          responseContainer.innerHTML = response.results.content
        }
        // @endif
      }
    } 
  }
  xhttp.onerror = exception => {
    let msg = ''
    if (xhttp.status == 0) {
      msg = 'Not connect.\n Verify Network.'
    } else if (xhttp.status == 404) {
      msg = 'Requested page not found. [404]'
    } else if (xhttp.status == 500) {
      msg = 'Internal Server Error [500].'
    } else if (exception === 'parsererror') {
      msg = 'Requested JSON parse failed.'
    } else if (exception === 'timeout') {
      msg = 'Time out error.'
    } else if (exception === 'abort') {
      msg = 'Ajax request aborted.'
    } else {
      msg = 'Uncaught Error.\n' + xhttp.responseText
    }
    console.error(msg)
    durationAndPrice.innerHTML = `<div class="error">${msg}</div>`
  }
  xhttp.open( 'POST', devia.ajax_url, true )
  xhttp.send( formData )
}